import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.pinyin.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_PINYIN_ASYNC: `${uid}.savePinyinsAsync`,
    SAVE_PINYIN_SUCCESS: `${uid}.savePinyinSuccess`,
    SAVE_PINYIN_FAILURE: `${uid}.savePinyinFailure`,
    CREATE_PINYIN: `${uid}.createPinyin`,
};

export { ActionTypes };
